import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

const schema = z.object({
    LaborServiceId: z.any().refine((val) => !!val, "Labor service is required"),
    UnitPrice: z.coerce.number().min(0.01, "Price must be greater than 0"),
    IsActive: z.coerce.number().optional().default(1),
});

const laborInventoryResolver = zodResolver(schema);

export default laborInventoryResolver;
